import { useTranslation } from "@redotech/redo-i18n";
import {
  type Auth,
  AuthContext,
} from "@redotech/redo-merchant-app-common/auth";
import {
  ONBOARDING_RESUME_SOURCE_PARAM,
  parseOnboardingResumeSource,
} from "@redotech/redo-onboarding-api/resume-source";
import { memo, useContext } from "react";
import { Navigate } from "react-router-dom";
import { autoOnboardingUrl } from ".";

export function getOnboardingLoginUrl(
  pathname: string,
  search: string,
): string {
  return `/login?next=${encodeURIComponent(pathname + search)}`;
}

export function getOnboardingRedirectUrl(
  auth: Pick<Auth, "teamId" | "token">,
  search: string,
  locale: string,
): URL {
  const source = parseOnboardingResumeSource(
    new URLSearchParams(search).get(ONBOARDING_RESUME_SOURCE_PARAM),
  );
  return autoOnboardingUrl(auth.token, auth.teamId, source, locale);
}

/**
 * Route component that redirects the user to the onboarding app with their
 * current auth token.  Used by the onboarding login modal so the flow is:
 *
 *   setup-vite (expired) → merchant login → /onboarding-redirect → setup-vite?token=…
 */
export const OnboardingRedirect = memo(function OnboardingRedirect() {
  const auth = useContext(AuthContext);
  const { i18n } = useTranslation();

  if (!auth) {
    return (
      <Navigate
        replace
        to={getOnboardingLoginUrl(location.pathname, location.search)}
      />
    );
  }
  location.href = getOnboardingRedirectUrl(
    auth,
    location.search,
    i18n.language,
  ).toString();

  return null;
});
